<script>
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import VideoItem from './VideoItem.vue'
import GridOptions from './GridOptions.vue'
import draggable from 'vuedraggable'
import NoVideo from './State/NoVideo.vue'

export default {
  components: {
    GridOptions,
    VideoItem,
    draggable,
    NoVideo,
  },
  mixins: [MixPanel, Helper],

  data() {
    const pathname = window.location.pathname.split('/')[1]
    return {
      allPlaylist: {},
      emptyPlaylist: [],
      arrKeyPlaylistIsPlay: [],
      uniqueVehicleIds: [],
      gridActive: 9,
      refresh: false,
      playlistDraggable: [],
      onDragMainPlaylistId: null,
      title:
        pathname === 'live-streaming'
          ? this.$t('menuitems.liveStreaming.text')
          : this.$t('menuitems.trackVideo.title'),
      innerWidth: 0,
    }
  },
  computed: {
    playerFullscreen() {
      return this.$refs.videoPlayerFullscreen.player
    },
    fleetOpen() {
      return this.$store.state.video.fleetOpen
    },
    fleetClose() {
      return this.$store.state.video.fleetClose
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      hasAccess: 'identity/hasAccess',
    }),
    ...mapGetters('video', ['vehicleStatusByVehicleId']),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    gridClass() {
      const classMapping = {
        1: 'one',
        4: 'four',
        6: 'six',
        8: 'eight',
        9: 'nine',
        16: 'sixteen',
        25: 'twenty-five',
      }
      return classMapping[this.gridActive]
    },

    listVideoPlaylistDraggableActive() {
      const videoActive = this.playlistDraggable.filter((item) => !item.isEmpty)
      return videoActive.map((item) => item.id)
    },
    isFromTrackvision() {
      return window.location.pathname.split('/')[1] === 'live-streaming'
    },
    isMobileView() {
      return this.innerWidth <= 480
    },
    isFullscreen() {
      return (isEmpty, isFullscreen) => {
        if (isEmpty) return false
        return isFullscreen
      }
    },
    isMainPlaylist() {
      return (isEmpty, playlistDragId) => {
        if (isEmpty)
          return this.getIndexNoChoice(playlistDragId) === 0 && !this.arrKeyPlaylistIsPlay.length
        if (this.onDragMainPlaylistId) return playlistDragId === this.onDragMainPlaylistId
        return (
          this.listVideoPlaylistDraggableActive.findIndex((_id) => _id === playlistDragId) === 0
        )
      }
    },
    isShowPlaylist() {
      return (isEmpty, playlistDragId) => {
        if (isEmpty)
          return (
            this.getIndexNoChoice(playlistDragId) <
            this.gridActive - this.arrKeyPlaylistIsPlay.length
          )
        return (
          this.listVideoPlaylistDraggableActive.findIndex((_id) => _id === playlistDragId) <
          this.gridActive
        )
      }
    },
  },
  watch: {
    async '$store.state.video.playlist'(playlist, oldPlaylist) {
      const vehicleIds = playlist.map((x) => x.vehicleId)
      const unique = Array.from(new Set(vehicleIds))
      this.uniqueVehicleIds = unique
      this.refresh = true

      if (playlist.length < oldPlaylist.length) {
        let arrRemovedPlaylist = []
        oldPlaylist.forEach((_playlist) => {
          if (!playlist.map((data) => data.id).includes(_playlist.id)) {
            arrRemovedPlaylist.push(_playlist.id)
          }
        })

        arrRemovedPlaylist.forEach((playlistId) => {
          this.$delete(this.allPlaylist, playlistId)
          this.playlistDraggable.splice(
            this.playlistDraggable.findIndex((item) => item.id === playlistId),
            1
          )
        })
      } else {
        for (let i = 0; i < playlist.length; i++) {
          const row = playlist[i]
          const isOldPlaylist = oldPlaylist.map((playlist) => playlist.id).includes(row.id)
          if (!isOldPlaylist) {
            this.allPlaylist[row.id] = {
              ...row,
              videoStatus: 'connecting',
              fullscreen: false,
            }
          }
        }
      }
      this.refresh = false
      const arrKeyIsPlay = Object.keys(this.allPlaylist)
      this.arrKeyPlaylistIsPlay = arrKeyIsPlay

      this.playlistDraggable = [
        ...this.getPlaylistVideoDraggable(),
        ...this.emptyPlaylist.map((_empty, index) => ({
          id: `empty-${index}`,
          isEmpty: true,
        })),
      ]

      this.$forceUpdate()

      // handle video demo
      setTimeout(() => {
        const dataDemoTrackvision = this.getFeatureFlagValue('vsms2_trackvision2_stream_demo_id')
        for (let i = 0; i < playlist.length; i++) {
          const row = playlist[i]
          const isVideoDemo = Object.keys(dataDemoTrackvision).includes(row.vehicleId)
          const isOldPlaylist = oldPlaylist.map((playlist) => playlist.id).includes(row.id)
          if (isOldPlaylist) continue
          if (isVideoDemo) {
            this.allPlaylist[this.getLastIndexPlaylist(row.id)].videoStatus = 'ready'
          }
        }
        this.$forceUpdate()
      }, 2000)
    },
    '$store.state.video.mapFlespiHowenState'(howenState) {
      const lastIndex = howenState.length - 1
      const lastHowenState = howenState[lastIndex]
      this.allPlaylist[this.getLastIndexPlaylist(lastHowenState.playlistId)].videoStatus = 'ready'
      this.allPlaylist[this.getLastIndexPlaylist(lastHowenState.playlistId)].src =
        lastHowenState.url
    },
    $route(to) {
      if (to.name === 'Live Streaming Trackvision') {
        this.title = this.$t('menuitems.liveStreaming.text')
      } else if (to.name === 'Track Video V2') {
        this.title = this.$t('menuitems.trackVideo.title')
      }
    },
    isMobileView(val) {
      if (val) {
        this.setGrid(this.$store.state.video.maxVideo)
      }
    },
  },

  async mounted() {
    for (let i = 0; i < this.$store.state.video.maxVideo; i++) this.emptyPlaylist.push(null)
    await this.$nextTick()
    const playlistDraggable = [
      ...this.emptyPlaylist.map((_empty, index) => ({
        id: `empty-${index}`,
        isEmpty: true,
      })),
    ]
    this.playlistDraggable = playlistDraggable

    // eslint-disable-next-line no-unused-vars
    window.addEventListener('popstate', this.handlePopState)

    // eslint-disable-next-line no-unused-vars
    document.addEventListener('fullscreenchange', this.handleFullscreenChange)

    this.innerWidth = window.innerWidth
    window.addEventListener('resize', this.handleResize)
    await this.$nextTick()
    if (this.innerWidth <= 480) {
      this.setGrid(this.$store.state.video.maxVideo)
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('popstate', this.handlePopState)
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange)
  },

  methods: {
    getVehicleStatusByVehicleId(vehicleId) {
      if (this.checkIsDemo(vehicleId)) {
        return {
          ...this.vehicleStatusByVehicleId(vehicleId),
          calculatedMotionStatus: 'M',
        }
      }
      return this.vehicleStatusByVehicleId(vehicleId)
    },

    checkIsDemo(vehicleId) {
      const dataDemoTrackvision = this.getFeatureFlagValue('vsms2_trackvision2_stream_demo_id')
      return Object.keys(dataDemoTrackvision)
        .map((id) => parseInt(id))
        .includes(vehicleId)
    },

    getLastIndexPlaylist(playlistId) {
      return Object.keys(this.allPlaylist).findLast((plalylistIndexId) =>
        plalylistIndexId.includes(playlistId)
      )
    },
    handleClickGridNumber(gridNumber) {
      this.track(`Video Streaming ${gridNumber} ${gridNumber === 1 ? 'Grid' : 'Grids'}`)
      this.setGrid(gridNumber)
    },

    setGrid(gridNumber) {
      this.gridActive = gridNumber
      this.$store.commit('video/setGridNumber', gridNumber)
    },

    /**
     *
     * @param playlistId format {vehicleId}:{channel}:{index}
     * @param key key in object playlist
     * @param value new value
     */
    setPlaylistValue(playlistId, key, value) {
      this.allPlaylist[playlistId][key] = value
    },

    /**
     * @param idNoChoice - format : empty-{index}
     */
    getIndexNoChoice(idNoChoice) {
      return parseInt(idNoChoice.split('-')[1])
    },

    checkMove(event) {
      const isFullscreen = this.listVideoPlaylistDraggableActive.some(
        (id) => this.allPlaylist[id].fullscreen
      )
      const itemMoved = event.draggedContext.element
      if (itemMoved.isEmpty || isFullscreen) return false
      const index = event.draggedContext.index
      const futureIndex = event.draggedContext.futureIndex
      if (futureIndex === 0) {
        this.onDragMainPlaylistId = itemMoved.id
      } else if (index === 0) {
        this.onDragMainPlaylistId = this.listVideoPlaylistDraggableActive[1]
      } else {
        this.onDragMainPlaylistId = null
      }
      return true
    },

    handleChangeDragGrid(_event) {
      this.onDragMainPlaylistId = null
      // make empty playlist to the last order
      const videoPlaylist = this.playlistDraggable.filter((playlist) => !playlist.isEmpty)
      const emptyPlaylist = this.playlistDraggable.filter((playlist) => playlist.isEmpty)
      this.playlistDraggable = [...videoPlaylist, ...emptyPlaylist]
    },

    getPlaylistVideoDraggable() {
      const prevPlaylistVideoDraggable = this.playlistDraggable
        .filter((item) => !item.isEmpty)
        .map((item) => item.id)
      const newPlaylist = Object.keys(this.allPlaylist).filter(
        (id) => !prevPlaylistVideoDraggable.includes(id)
      )
      return [...prevPlaylistVideoDraggable, ...newPlaylist].map((id) => ({
        id,
        isEmpty: false,
      }))
    },
    handleResize() {
      this.innerWidth = window.innerWidth
    },
    handlePopState() {
      if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
        document.body.classList.remove('mc-trackvideo-fullscreen--detail')
      }
    },
    handleFullscreenChange() {
      const isExitFullscreen = document.fullscreenElement === null
      if (isExitFullscreen) {
        if (document.body.classList.contains('mc-trackvideo-fullscreen--detail')) {
          Object.keys(this.allPlaylist).forEach((playlistId) => {
            if (this.allPlaylist[playlistId].fullscreen) {
              this.allPlaylist[playlistId].fullscreen = false
            }
          })
          document.body.classList.remove('mc-trackvideo-fullscreen--detail')
          this.$forceUpdate()
        }
      }
    },
  },
}
</script>

<template>
  <div class="mc-map mc-trackvideo-content bg-white border mc-liveview__map">
    <div class="d-flex justify-content-between p-2 border-bottom">
      <h4 class="mc-page-title mc-live-streaming__title">{{ title }}</h4>
      <GridOptions :isMobileView="isMobileView" @clickGridNumber="handleClickGridNumber" />
    </div>
    <div class="mc-trackvideo-video-grid__wrapper">
      <draggable
        v-model="playlistDraggable"
        class="mc-trackvideo-card"
        :class="`mc-trackvideo-card--${gridClass}`"
        :move="checkMove"
        :disabled="isMobileView"
        @change="handleChangeDragGrid"
      >
        <div
          v-for="(playlistDrag, index) in playlistDraggable"
          v-show="isShowPlaylist(playlistDrag.isEmpty, playlistDrag.id)"
          :id="`playlist-${playlistDrag.id}`"
          :key="playlistDrag.id"
          class="mc-trackvideo-card__item"
          :class="{
            'mc-trackvideo__main-playlist': isMainPlaylist(playlistDrag.isEmpty, playlistDrag.id),
            'mc-trackvideo-card__item--fullscreen': isFullscreen(
              playlistDrag.isEmpty,
              allPlaylist[playlistDrag.id]?.fullscreen ?? false
            ),
          }"
        >
          <VideoItem
            v-if="!playlistDrag.isEmpty"
            :playlist-id="playlistDrag.id"
            :playlist="allPlaylist[playlistDrag.id]"
            :unique-vehicle-ids="uniqueVehicleIds"
            :calculatedMotionStatus="
              getVehicleStatusByVehicleId(allPlaylist[playlistDrag.id].vehicleId)
                .calculatedMotionStatus
            "
            @setPlaylistValue="setPlaylistValue"
          />
          <NoVideo v-else />
        </div>
      </draggable>
    </div>
  </div>
</template>
